export class BookAnimationController {
  constructor(private animationData: string) {}

  /**
   * Update height of animation
   * then there is nothing you should update.
   *
   * Because animation json uses repeaters witch add up
   * every time you use same animation, its better to convert animation
   * to json and pass animation like JSON.parse(animationData);
   */
  public setHeight(value: number) {
    const animData = JSON.parse(this.animationData) as any;
    (animData.layers[0].ks.p.k[1] as any).s[1] = value;
    (animData.layers[0].ks.p.k[2] as any).s[1] = value;

    this.animationData = JSON.stringify(animData);

    // (this.animationData.layers[0].ks.p.k[1] as any).t =
    //   value / (oldHeight / c1Timing);
  }

  /**
   * Update something very important.
   * @returns Animation JSON imported data that is passed into constructor
   */
  public getAnimationData(): any {
    return JSON.parse(this.animationData);
  }
}
